module.exports = __webpack_public_path__ + "static/img/Split.974b60c0.jpg";